import {
    changeSelectedIds,
    getDataForDownload,
    getDataForDownloadRegItems,
    getDataTable,
    getDataTableForRegularPrices,
    sendEffectiveBarCodesToServer,
    sendSaleIdsToServer,
    setDataPrintStatus,
    setPreloader,
    setSelectedRow
} from "../../Redux/content-reducer";
import {connect} from "react-redux";
import Header from "./Header";
import {
    getFormat,
    setFormat,
    setProductCategoryPricesDispatcher,
    setProductCategoryPromosDispatcher, setSupplierPricesDispatcher, setSupplierPromosDispatcher
} from "../../Redux/format-reducer";



let mapStateToProps = (state) => {
    return {
        data: state
    }
};

let mapDispatchToProps = {
    setDataPrintStatus,
    getDataForDownload,
    setSelectedRow,
    setFormat,
    getFormat,
    sendSaleIdsToServer,
    sendEffectiveBarCodesToServer,
    changeSelectedIds,
    setProductCategoryPromosDispatcher,
    setProductCategoryPricesDispatcher,
    setSupplierPromosDispatcher,
    setSupplierPricesDispatcher,
    getDataTable, getDataTableForRegularPrices,
    setPreloader,
    getDataForDownloadRegItems
};


export default connect(mapStateToProps, mapDispatchToProps)(Header);
